import { render } from "./StylesForMolType.vue?vue&type=template&id=22cc30f7&ts=true"
import script from "./StylesForMolType.vue?vue&type=script&lang=ts"
export * from "./StylesForMolType.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__